import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
// MainLayout must be a function to use hooks
const MainLayout = ({ children }) => {
    // Sidebar open state for mobile/tablet
    const [sidebarOpen, setSidebarOpen] = React.useState(false);

    const toggleSidebar = () => setSidebarOpen((prev) => !prev);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div className="h-screen bg-gray-50 overflow-hidden flex flex-col">
            {/* Header spans full width at top */}
            <Header toggleSidebar={toggleSidebar} />

            {/* Overlay for mobile/tablet when sidebar is open */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/30 backdrop-blur-sm z-[60] lg:hidden"
                    onClick={closeSidebar}
                    aria-label="Close sidebar overlay"
                />
            )}

            {/* Below header: sidebar and main content side by side */}
            <div className="flex flex-1 min-h-0">
                {/* Sidebar (fixed width, scrollable if needed) */}
                <aside
                    className={`w-64 bg-white shadow-2xl rounded-r-2xl overflow-y-auto
                        transition-all duration-300 ease-in-out
                        ${sidebarOpen ? 'block fixed top-16 left-0 h-[calc(100vh-4rem)] z-[70]' : 'hidden'}
                        lg:static lg:block lg:h-auto lg:z-auto lg:rounded-none lg:shadow`
                    }
                >
                    <Sidebar isOpen={sidebarOpen} closeSidebar={closeSidebar} />
                </aside>

                {/* Main content area - compact padding for all */}
                <main className="flex-1 px-6 py-4 bg-gray-50 overflow-y-auto min-h-0 flex flex-col">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
